"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Leader_3d_1 = __importDefault(require("./Leader.3d"));
const Cad3d_scss_1 = __importDefault(require("../Cad3d.scss"));
class PointToPointLeader extends Leader_3d_1.default {
    constructor(viewer, material, prefix, deltaLabelColor) {
        super(viewer, material, prefix);
        this.deltaLabelColor = deltaLabelColor;
        this.label = this.createLabel();
        this.yCoordGap = -32;
    }
    drawByLinePoints(startPoint, endPoint, lineStartPoint, lineEndPoint) {
        this.drawLine(lineStartPoint, lineEndPoint);
        this.drawLabel(startPoint, endPoint, true);
        this.updateLabelPosition();
    }
    createLabel() {
        if (!this.deltaLabelColor) {
            return super.createLabel();
        }
        const label = document.createElement('div');
        label.classList.add(Cad3d_scss_1.default.measurementLabelContainer);
        this.deltaPart = document.createElement('div');
        this.deltaPart.classList.add(Cad3d_scss_1.default.deltaLabel);
        this.deltaPart.style.backgroundColor = this.deltaLabelColor.getStyle();
        label.appendChild(this.deltaPart);
        this.measurementPart = document.createElement('div');
        this.measurementPart.classList.add(Cad3d_scss_1.default.measurementLabel);
        label.appendChild(this.measurementPart);
        return label;
    }
    setLabelText(text, prefix) {
        this.deltaPart.innerText = prefix;
        this.measurementPart.innerText = text;
    }
}
exports.default = PointToPointLeader;
